<template>
    <div class="container-fluid">
        <form class="form-horizontal" @submit.prevent="getAllConsumptionList" style="margin-top: 20px">
            <div class="form-group">
                <label class="col-item  control-label">
                    <strong>消费时间:</strong>
                </label>
                <div class="col-item">
                    <v-datepicker v-on:input="clearSelectedIndex" style="width: 200px; display: inline-block" v-model="useTimeStart" :message="useTimeStart"></v-datepicker>到
                    <v-datepicker v-on:input="clearSelectedIndex" style="width: 200px; display: inline-block" v-model="useTimeEnd" :message="useTimeEnd"></v-datepicker>
                </div>
            </div>
            <div class="form-group" style="margin-left: 98px">
                <div>
                    <span class="time-filter" :class="{'active' : selectedIndex === 0 }" v-on:click="before(0,0)">今天</span>
                    <span class="time-filter" :class="{'active' : selectedIndex === 1}" v-on:click="before(1,3)">近三天</span>
                    <span class="time-filter" :class="{'active' : selectedIndex === 2}" v-on:click="before(2,7)">近七天</span>
                    <span class="time-filter" :class="{'active' : selectedIndex === 3}" v-on:click="before(3,30)">近30天</span>
                </div>
            </div>
            <div class="form-group" style="margin-left: 104px">
                <button class="btn btn-warning" type="submit">查询</button>
            </div>
        </form>
        <div class="common-tip-blk">
            <i class="F-glob F-glob-status-info"></i>
            <strong>合计</strong>
            <span>{{useTimeStart}}</span>至
            <span>{{useTimeEnd}}</span>已验证了
            <span>{{totalVerifyNum||0}}</span>张,已撤销
            <span>{{totalRevocationNum||0}}</span>张
        </div>
        <div class="table-wrapper" v-loading="isTableLoading" element-loading-text="拼命加载中">
            <div class="pull-right">
                <a :href="apiHost+generateUrl" target="_blank">下载明细记录</a>
            </div>
            <table class="table table-hover table-bordered">
                <thead>
                    <tr>
                        <th>订单号</th>
                        <th>操作时间</th>
                        <th>类型</th>
                        <th>项目名称</th>
                        <th>电子票密码</th>
                        <th>操作数量</th>
                        <th>操作人</th>
                        <th>来源</th>
                        <th>消费者购买价</th>
                        <th>总价</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in consumptionList">
                        <td>
                            <a :href="otpHost+detailUrl+item.orderId">{{item.orderId}}</a>
                        </td>
                        <td>
                            {{item.operationTime|formdate}}
                        </td>
                        <td>
                            {{item.operationType == 1 ? '验证' : '撤销'}}
                        </td>
                        <td>
                            <ul class="list-unstyled">
                                <li>
                                    <a :href="programNameUrl+item.dealId+'.html'" target="_blank">{{item.dealName}}</a>
                                </li>
                                <li ng-if="item.ticketType">
                                    {{item.ticketType}}
                                </li>
                            </ul>
                        </td>
                        <td>
                            <strong>{{item.voucherCode}}</strong>
                        </td>
                        <td>
                            {{item.quantity}}
                        </td>
                        <td>{{item.operatorName}}</td>
                        <td>{{item.source}}</td>
                        <td>
                            {{item.sellPrice}}
                        </td>
                        <td>
                            {{item.totalPrice}}
                        </td>
                    </tr>
                </tbody>
            </table>
            <p class="nodata" v-if="noData">未查询到匹配内容</p>
            <v-pagination class="pull-right" :current='current' :total='totalPage' :size="'md'" :first="false" :last="false" v-on:current-change="currentChangeFunc($event)">
            </v-pagination>
        </div>
    </div>
</template>
<script>
    import api from "api/verifyHistory";
    import { formatDate as formdate } from "helpers";
    import { apiHost, otpHost } from "config/env.conf.js";
    export default {
        data() {
            return {
                options1: {},
                msg: "",
                consumptionList: [],
                current: 1,
                perPageCount: 10,
                totalCount: 0,
                isTableLoading: false,
                useTimeEnd: "",
                useTimeStart: "",
                bizAccountAccess: "",
                noData: false,
                totalVerifyNum: 0,
                totalRevocationNum: 0,
                selectedIndex: 0,
                dealId: "",
                searchInfo: false,
                baseUrl: "/meilv/scs/account/v1/voucher/log/excel?",
                apiHost: apiHost,
                otpHost: otpHost,
                formdate: formdate,
                detailUrl: "#/ticket/order/ticket/detail?id=",
                programNameUrl: "https://www.meituan.com/deal/"
            };
        },
        filters: {
            formdate(time) {
                var date = new Date(time);
                return formdate(date, "yyyy-MM-dd hh:mm:ss");
            }
        },
        created: function() {
            this.searchInfo = true;
            if (this.searchInfo) {
                this.before(0, 0);
            }
            this.getAllConsumptionList();
        },
        computed: {
            totalPage() {
                return Math.ceil(this.totalCount / this.perPageCount);
            },
            generateUrl() {
                return (
                    this.baseUrl +
            "useTimeStart=" +
            this.useTimeStart +
            "&useTimeEnd=" +
            this.useTimeEnd
                );
            }
        },
        methods: {
            getFormateDate(date) {
                return this.formdate(date, "yyyy-MM-dd");
            },
            alert(message) {
                this.$alert({
                    title: "提示",
                    message: message,
                    showCancelButton: false,
                    closeOnClickModal: false
                });
            },
            clearSelectedIndex() {
                this.selectedIndex = "";
            },
            getAllConsumptionList() {
                this.isTableLoading = true;
                if (!this.check()) {
                    return;
                }
                api
                    .getAllConsumptionList({
                        useTimeEnd: this.useTimeEnd,
                        useTimeStart: this.useTimeStart,
                        pageNo: this.current,
                        pageSize: this.perPageCount,
                        bizAccountAccess: "web"
                    })
                    .then(response => {
                        this.isTableLoading = false;
                        if (response.status === 0) {
                            if (response.data) {
                                this.consumptionList = response.data.list;
                                this.totalVerifyNum = response.data.totalVerifyNum;
                                this.totalRevocationNum = response.data.totalRevocationNum;
                                this.totalCount = response.data.totalSize;
                            }
                            if (response.data.totalSize === 0) {
                                this.noData = true;
                            } else {
                                this.noData = false;
                            }
                        } else {
                            this.alert(response.message || "接口返回信息有误");
                        }
                    })
                    .catch(error => {
                        this.isTableLoading = false;
                        this.consumptionList = [];
                        this.alert(error.message || error);
                    });
            },
            currentChangeFunc(data) {
                this.current = data.current;
                this.getAllConsumptionList();
            },
            before(index, day) {
                let today = new Date();
                let nowVal = today.valueOf();
                let TimeStart = new Date(nowVal - day * 24 * 60 * 60 * 1000);
                this.useTimeStart = this.getDateTime(TimeStart);
                this.useTimeEnd = this.getDateTime(today);
                this.selectedIndex = index;
                //this.getAllConsumptionList();
            },
            getDateTime(date) {
                let result = "";
                if (date) {
                    result += date.getFullYear() + "-";
                    let month = date.getMonth() + 1;
                    result += month < 10 ? "0" + month : month;
                    result += "-";
                    let dateInMonth = date.getDate();
                    result += dateInMonth < 10 ? "0" + dateInMonth : dateInMonth;
                }
                return result;
            },
            check() {
                if (!this.useTimeStart || !this.useTimeEnd) {
                    this.alert("必须选择起止时间!");
                    return false;
                }
                if (this.useTimeStart > this.useTimeEnd) {
                    this.alert("开始时间必须小于结束时间!");
                    return false;
                }
                return true;
            }
        }
    };
</script>

<style lang="scss" scoped>
.container-fluid {
  .time-filter {
    display: inline-block;
    padding: 3px 10px;
    margin: 0 5px;
    border: 2px solid #eee;
    color: #2bb8aa;
    cursor: pointer;
  }

  .active {
    background-color: #2bb8aa;
    color: white;
  }

  .col-item {
    position: relative;
    min-height: 1px;
    padding-left: 20px;
    padding-right: 15px;
    display: inline-block;
  }
  .common-tip-blk {
    border: 1px solid #eee;
    line-height: 40px;
    padding: 0 20px;
    margin-top: 10px;
    .F-glob {
      color: #2bb8aa;
      font-size: 16px;
      font-family: global-iconfont;
      font-style: normal;
      font-weight: 400;
      speak: none;
      text-decoration: none;
      -webkit-font-smoothing: antialiased;
    }
    .F-glob-status-info:before {
      content: "\e90e";
    }
  }

  .table-wrapper {
    .pull-right {
      float: right !important;
      color: #2bb8aa;
      cursor: pointer;
    }
  }
  .nodata {
    width: 120px;
    margin: 0 auto;
  }
}
</style>







// WEBPACK FOOTER //
// allProgramConsumption.vue?59ca8ba0